/* Keep Searchanise's filter operations and native close handlers intact. */
(() => {
  'use strict';
  const selector = '#snize-modal-mobile-filters-dialog, #snize-modal-mobile-sortby-dialog';
  const triggerSelector = '.snize-main-panel-mobile-filters > a, #snize_results .snize-main-panel-dropdown > a';
  let opener = null;
  const mounted = new WeakMap();
  let active = null;

  function mount(modal) {
    if (mounted.has(modal)) { mounted.get(modal)(); return; }
    if (!window.DACLibraryCards) return;
    const close = modal.querySelector(':scope > button.snize-close-button');
    if (!close) return;
    window.DACCloseControl?.apply(close);
    const title = modal.querySelector('#snize_filters_block_header .snize-product-filters-title, .snize-sortby-title');
    if (title?.textContent.trim()) modal.setAttribute('aria-label', title.textContent.trim());
    modal.setAttribute('aria-modal', 'true');
    modal.tabIndex = -1;
    let controller = null;
    const sync = () => {
      const open = modal.isConnected && getComputedStyle(modal).display !== 'none';
      if (open && !controller) {
        controller = window.DACLibraryCards.openModal(modal, opener || document.querySelector(triggerSelector), {
          persistent: true,
          onClose: () => close.click()
        });
        active = { modal, sync };
      } else if (!open && controller) {
        controller.release(); controller = null;
        if (active?.modal === modal) active = null;
        if (!opener?.isConnected) document.querySelector(triggerSelector)?.focus();
      }
    };
    mounted.set(modal, sync);
    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });
    sync();
  }

  function start() {
    document.addEventListener('click', event => {
      const trigger = event.target.closest(triggerSelector);
      if (trigger) opener = trigger;
    }, true);
    document.querySelectorAll(selector).forEach(mount);
    new MutationObserver(records => {
      if (active && !active.modal.isConnected) active.sync();
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches(selector)) mount(node);
        node.querySelectorAll(selector).forEach(mount);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
